<template>
  <a-modal 
    :title="title" 
    :visible="hidden"
    @ok="ok" 
    @cancel="cancel"
    :forceRender="true"
    :destroyOnClose="true"
    :maskClosable="false"
    width="800px"
    okText="确定"
    cancelText="取消">
    <a-form-model
      ref="ruleForm"
      class="create-form"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :validateOnRuleChange="true"
      :wrapper-col="wrapperCol"
    >
      <!-- <a-form-model-item label="配方代码" prop="formulaCode">
        <a-input size="small" placeholder="输入配方代码" v-model="form.formulaCode" />
      </a-form-model-item> -->
      <a-form-model-item label="配方分类" prop="typeClassify">
        <a-radio-group v-model="form.typeClassify">
          <a-radio :value="1">自产配方</a-radio>
          <a-radio :value="2">代工配方</a-radio>
          <a-radio :value="3">定制配方</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="配方名称" prop="formulaName">
        <a-input size="small" placeholder="输入配方名称" v-model.trim="form.formulaName" />
      </a-form-model-item>
      <a-form-model-item label="动物类型" prop="animal">
        <a-input
          v-if="form.id && isChange"
          :style="inputStyle"
          v-model="animalName"
          placeholder="请选择动物类型"
        >
          <a-icon slot="suffix" type="down" style="font-size: 12px;color: #ccc;" />
        </a-input>
        <a-cascader
          ref="cascader"
          :style="form.id ? cascaderStyle : ''"
          :options="animal"
          :load-data="loadAnimalData"
          @change="onChange"
          
          size="small"
          v-model="form.animal"
          placeholder="请选择动物类型"
        />
       <!-- <div v-if="item">{{form.animalType}}</div> -->
      </a-form-model-item>
      <!-- <a-form-model-item label="配方模型"  prop="modelId">
        <a-select
          @select="modelChange"
          placeholder="选择配方模型"
          :allowClear="true"
          @change="modelSelect"
          v-model="form.modelId"
        >
          <a-select-option v-for="(item,index) in model.records" :key="index" :title="item.name" :value="item.id">
            {{item.name}}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label=" "  :colon="false">
        <a-radio-group v-model="form.isFilledModel">
          <a-radio :value="0">模型不填充配方</a-radio>
          <a-radio :value="1">模型填充配方</a-radio>
        </a-radio-group>
      </a-form-model-item> -->
      <a-form-model-item label="养分选择表"  prop="linkId">
        <a-select
          @change="nutritionChange"
          placeholder="选择养分表"
          :defaultValue="defaultNutrition"
          :allowClear="true"
          v-model="form.linkId"
        >
          <a-select-option v-for="(item,index) in nutrition.records" :title="item.name" :key="index" :value="item.id">
            {{item.name}}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="priceSource">
        <span slot="label">
          优化价格来源&nbsp;
          <a-tooltip title="配方优化成本和计算配方中原料用量的价格来源">
            <a-icon type="exclamation-circle" />
          </a-tooltip>
        </span>
        <!-- <a-select placeholder="选择优化价格来源" v-model="form.priceSource" :options="priceOption" /> -->
        <a-select placeholder="选择优化价格来源" v-model="form.priceSource" @change="() => changeSource('priceSourceChange')">
          <a-select-option v-for="el in priceOption" :key="el.value" :disabled="el.value === form.referPriceSource">{{ el.label }}
        </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="priceSourcex">
        <span slot="label">
          参考价格来源&nbsp;
          <a-tooltip title="使用参考来源下的原料价格计算配方的参考成本">
            <a-icon type="exclamation-circle" />
          </a-tooltip>
        </span>
        <a-select placeholder="选择参考价格来源" v-model="form.referPriceSource" allowClear @change="() => changeSource('referPriceSourceChange')">
          <a-select-option v-for="el in priceOption" :key="el.value" :disabled="el.value === form.priceSource">{{ el.label }}
        </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="设定盘重" prop="totalWeight">
        <a-input size="small" type="number" v-model="form.totalWeight">
          <a-space slot="addonAfter">KG</a-space>
        </a-input>
      </a-form-model-item>
      <a-form-model-item label="分析基础" prop="analysisBase">
        <a-input size="small" v-model="form.analysisBase" :disabled="true">
          <a-space slot="addonAfter">KG</a-space>
        </a-input>
      </a-form-model-item>
      <a-form-model-item label="日粮与补充料比例" prop="selfProvidedProportion">
        <a-input-number style="width: 30%;margin-top:10px;" size="small" :precision='3' :max="100" :min='0' :step="0.001" v-model="formValue.selfProvidedProportion" @change="e => changeMix(e,'formValue.selfProvidedProportion')" />
        <span style="width: 5%;text-align: center;display: inline-block;">:</span>
        <a-input-number style="width: 30%;margin-top:10px;" size="small" :precision='3' :step="0.001" :max="100" :min='0' v-model="dayValue"  @change="e => changeMix(e,'dayValue')" />
      </a-form-model-item>
      
      <a-form-model-item ref="remark" label="备注" prop="remark">
        <a-textarea size="small" v-model="form.remark" placeholder="输入备注" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
// import MenuNode from '../../../Material/MaterialManagement/MaterialEdit/MenuNode.vue'
import {nhfMixins} from '../../untils'
// import AnimalSelect from '../select/AnimalSelect.vue'

export default {
  // components: { MenuNode },
  // components: { AnimalSelect },
  props:['hidden'],
  mixins:[nhfMixins],
  data(){
    return {
      isChange: true,
      animalName: '',
      inputStyle: 'position: absolute;width: 100%;top:-7px;opacity: 1;background: #fff;top:-1px;color:rgba(0, 0, 0, 0.65);',
      cascaderStyle: 'opacity: 0',
      dayValue: '',
      modelCache:[],
      formValue:{
        model:'选择配方模型',
        animal:'选择动物类型',
        price:'选择价格来源',
        selfProvidedProportion: ''
      },
      nutrition:{
        records:[],
      },
      animal:[],
      title:'新建配方',
      // form: this.$form.createForm(this, { name: 'add-formula' },{
      //     totalWeight:1000,
      //   analysisBase:1,
      //   analysisBaseUnit:'Kg',
      //   priceSource: '4',
      //   isFilledModel:0,
      //   selfProvidedProportion: '',
      //   animal: []
      // }),
      form:{
        typeClassify: 1,
        totalWeight:1000,
        analysisBase:1,
        analysisBaseUnit:'Kg',
        priceSource: '4',
        isFilledModel:0,
        selfProvidedProportion: '',
        animal: [],
        modelId: undefined
      },
      rules: {
        typeClassify:[{required: true, message: '请选择配方分类', trigger: 'change'},],
        formulaCode: [{ required: true, validator:this.validatorCode, trigger: 'change' }],
        formulaName: [{ required: true, message: '请输入配方名称', trigger: 'change' },
          {validator: this.validatorName, trigger: 'change'}],
        animal: [{ required: true, message: '请选择动物类型', trigger: 'blur' }],
        // modelId: [{ required: true, message: '选择配方模型', trigger: 'change' }],
        priceSource: [{ required: true, message: '选择价格来源', trigger: 'change' }],
        linkId: [{ required: true, message: '选择养分', trigger: 'change' }],
        totalWeight: [{ required: true, message: '请输入盘重设定', trigger: 'change' }],
        selfProvidedProportion: [{ required: true, message: '请输入日粮与补充料比例', trigger: 'change' }],
        // dayValue: [{ required: true, message: '请输入补充料占比', trigger: 'change' }],
        checkTitle: '',
      },
      maxLen2: 31
    }
  },
  computed:{
    priceval(){
      return this.price[this.from.priceSource - 1]
    },
    defaultModel(){
      return this.form && this.form.model && this.form.model.records && this.form.modelId ? this.model.records.filter(i=>i.id === this.form.modelId)[0].name : null
    },
    defaultPrice(){
      return this.form && this.form.priceSource && this.item && this.item.priceSource ? this.priceOption[this.item.priceSource - 1].label : null
    },
    defaultNutrition(){
      // return this.form && this.form.linkId ? this.nutritionList.map(i=>i.id === this.form.linkId)[0].name : null
      return this.form && this.form.linkId ? this.nutrition.records ? this.nutrition.records.map(i=>i.id === this.form.linkId)[0].name : [] : null
    },
    animalDefault(){
      return [this.form ? this.form.animalTypeCode : null]
    },
  },
  mounted(){
  },

  watch:{
    hidden(val){
      if(val){
        this.init()
        if( this.formulaId){
          this.title="编辑配方"
          // this.formValue.price = '市场价格'
          this.detailInit()
          this.isChange = true
        }
      }else{
        this.dayValue = ''
      }
    },
  },
  
  methods:{
    changeSource(feild){
      this.setState({[`${feild}`]: true})
    },
    validatorName(rule, value, callback) {
      let msg = ''
      // let flag = false
      // let reg2 = /[`/\\~!@$^&_+=<>?:"{}|^%,;'[\]·~！@￥……&——+={}|《》？：“”【】、；‘’，。、]/im;
      // [] ： * ?< > / \ 、
      let reg2 = /[*[\]：？<>/、\\.]/im;
      if(reg2.test(value)){
        // msg = `配方名称不能包含\`/\\~!@$^&_+=<>?:"{}|^%,;'[]·~！@￥……&——+={}|《》？：“”【】、；‘’，。、等特殊字符`
        // flag = true
        msg = '配方名称不能包含*[]：？<>/、\\.等特殊字符'
      }
      // 长度
      // let len = this.getCharLen(value)
      let len = value.length
      if(len > this.maxLen2){
        msg = `配方名称长度不能超过${this.maxLen2}个字符`
      }
      if(msg) callback(new Error(msg))
      callback()
    },
    getCharLen(str=''){
      let len = 0
      let strArr = str.split('')
      strArr && strArr.forEach(el => {
        if(el.charCodeAt() > 255){
          len += 3
        }else{
          len++
        }
        if(len <= this.maxLen2){
          this.checkTitle += el
        }
      })
      return len
    },
    checkNameLen(e){
      let val = e.target.value
      this.checkTitle = ''
      let len = this.getCharLen(val)
      if(len > this.maxLen2){
        this.form.formulaName = this.checkTitle
        this.$message.warning(`配方名称长度不能超过${this.maxLen2}个字节`)
      }
    },
    changeMix(val,feild){
      if(val || val === 0){
        if(feild === 'formValue.selfProvidedProportion'){
          this.form.selfProvidedProportion = val
          this.formValue.selfProvidedProportion = val
          this.dayValue = 100 - val
        }else{
          this.form.selfProvidedProportion = 100 - val
          this.formValue.selfProvidedProportion = 100 - val
        }
      }else{
        this.dayValue = ''
        this.form.selfProvidedProportion = ''
        this.formValue.selfProvidedProportion = ''
      }
      this.$refs.ruleForm.validateField('selfProvidedProportion')
    },
    init(){
      this.factoryId = window.localStorage.getItem('factoryId')
      const {id} = this.$route.query
      this.formulaId = id
      // this.getModelList()
      this.getNutrition()
      this.initAnimal()
    },
    async validatorCode(rule,formulaCode,callback){
      let pattern =/^[A-Za-z0-9]+$/
      if(formulaCode.length){
        if(!pattern.test(formulaCode)){
          callback(new Error('配方代码只能由数字和字母组成'))
          return
        }
        const result = await this.fetchPost({
          actions:this.checkFormulaCodeIsUnique,
          showMessage:false,
          data:{
            formulaCode
          }
        })
        result ? callback() : callback(new Error('配方代码重复'))
      }else{
       callback(new Error('请输入配方代码')) 
      }
    },
    nutritionChange(val){
      this.form.linkId = val
    },
    async detailInit(){
      await this.getDetail()
      // this.from.animal = []
      this.$nextTick(()=>{
        let mo = this.model.records.filter(i=>i.id === this.form.modelId)[0]
        this.formValue.model = mo ? mo.name : null
        this.formValue.animal = this.form.animalTypeName
        this.animalName = this.form.animalTypeName
        // this.form.animal = []
        // this.form.animal.push(this.form.animalTypeCode)
        this.formValue.animalTypeName = this.form.animalTypeName
        this.form.modelId = this.form.modelId ? this.form.modelId : undefined
        this.form.referPriceSource = this.form.referPriceSource ? this.form.referPriceSource : undefined
        // this.form.priceSource = this.price[this.form.priceSource-1]
        let {formulaExtMix} = this.form || {}
        this.formValue.selfProvidedProportion = formulaExtMix.selfProvidedProportion || 0
        this.form.selfProvidedProportion = formulaExtMix.selfProvidedProportion || 0
        this.dayValue = 100 - (this.formValue.selfProvidedProportion || 0)
        this.getLine()
      })
      // await this.getModelList()
    },
    async getDetail(){
      await this.fetchGet({
        actions:this.mixDetail,
        name:'form',
        data:{
          feild: 'animal',
          formulaId:this.formulaId,
        }
      })
    },
    getNutrition(arg ={}){
      this.fetchGet({
        actions:this.animalNutritionUserPage,
        name:'nutrition',
        data:{
          ...arg,
          size:1000
        }
      })
    },

    animalChange(val){
      this.isChange = false
      if(val && val.length > 0){
        if(val.length > 1){
          const {name,id} =[...val].pop()
          const {id:animalRootId} = [...val][0]
          this.form.animalRootId = animalRootId
          this.form.animalTypeName = name
          this.form.animalTypeCode = id
          this.inputStyle = 'display: none'
          this.cascaderStyle = ''
          this.animalName = name
        }
      } else{
        this.inputStyle = 'display: none'
        this.form.animalTypeName = undefined
        this.form.animalTypeCode = undefined
        this.animalName = undefined
        this.form.animal = []
          this.form.animalRootId = ''
      }
    },

    priceChange(val){
      this.form.price= val
    },

    modelSelect(val){
      if(val === undefined) {
        this.form.modelId = ''
      }
    },

    modelChange(val){
      this.form.isFilledModel = 0
      const item = this.model.records.filter(i=>i.id === val)[0]
      const {id} = item
      this.form.modelId = id
    },

    async getModelList(arg={}){
      await this.fetchGet({
        actions:this.formulaModel,
        data:{
          size:300,
          current:1,
          animalTypeId: this.form.lineId,
          ...arg
        },
        name:'model'
      })
      if(this.model.records.length === 0) {
        this.model.records = []
      } else {
        this.model.records = this.model.records.filter(el => !this.modelIds.includes(el.id))
        this.modelCache = JSON.parse(JSON.stringify(this.model.records))
        this.formValue.model = '选择配方模型'
      }
    },

    // 创建配方
    ok(){
      this.$refs.ruleForm.validate( async (valid) => {
        if (valid) {
          const {type} = this.$route.query
          const {analysisBase,analysisBaseUnit,animalTypeCode,animalTypeName,totalWeight,formulaName,factoryId,id,modelId,remark,priceSource,linkId,isFilledModel,selfProvidedProportion,animalRootId,referPriceSource=null,typeClassify} = this.form
          let {formulaExtMix: mix} = this.form
          let formulaExtMix = {
            id: mix ? mix.id : undefined,
            selfProvidedProportion
          }
          const resData = {analysisBase,analysisBaseUnit,animalTypeCode,animalTypeName,totalWeight,formulaName,factoryId,modelId: modelId && modelId.length === 0 ? undefined : modelId,remark,priceSource,linkId,isFilledModel,formulaType:  type || 2 ,formulaExtMix,animalRootId,referPriceSource,typeClassify}
          if(id) resData.id = id
          this.cleanForm()
          this.$emit('ok',resData)
        }
      })
    },

    cancel(){
      this.cleanForm()
      this.$emit('cancel')
    },

    cleanForm(){
      this.$refs.ruleForm.resetFields()
      this.form = {
        typeClassify: 1,
        totalWeight:1000,
        analysisBase:1,
        analysisBaseUnit:'Kg',
        priceSource: '4',
        isFilledModel:0,
        selfProvidedProportion: '',
        animal: []
      }
      this.formValue = {
        model:'选择配方模型',
        animal:'选择动物类型',
        price:'选择价格来源'
      }
      this.inputStyle = 'position: absolute;width: 100%;top:-7px;opacity: 1;background: #fff;top:-1px;color:rgba(0, 0, 0, 0.65);'
      this.cascaderStyle = 'opacity: 0'
    },

    onChange(val,select){
      this.form.modelId = undefined
      this.animalChange(select)
      this.getLine()
      // this.$emit('change', val)
      // this.$emit('select', selected)
    },
    async getLine(){
      let res = await this.fetchGet({
        actions:this.selectLineAnimalByAnimalId,
        data:{
          animalId: this.form.animalTypeCode,
        },
      })
      let {success,data} = res || {}
      if(success) {
        let {lineId} = data || {}
        this.form.lineId = lineId
        this.getModelList()
      }
    },

    mapFilter (i) {
      return {
        ...i,
        label:i.name,
        value:i.id,
        isLeaf: !i.hasChildren
      } 
    },

    async loadAnimalData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true
      const {value:parentId} = targetOption
      let factoryId = window.localStorage.getItem('factoryId')
      const res = await this.animalTypeList({parentId,factoryId})
      targetOption.loading = false
      res.data = res.data.filter(el => !this.deleteIds.includes(el.id))
      targetOption.children = res.data.map(this.mapFilter)
      this.animal = [...this.animal]
    },

    async initAnimal(){
      let factoryId = window.localStorage.getItem('factoryId')
      const res = await this.animalTypeList({parentId:0,factoryId})
      const {data} = res
      if(data && data.length && data[0].id){
        const resAnimal = await this.animalTypeList({parentId:data[0].id,factoryId})
        this.animal = resAnimal.data.map(this.mapFilter)
      } else{
        this.animal = res.data.map(this.mapFilter)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  ::v-deep .ant-form-item{
    margin-bottom: 0;
  }
  ::v-deep .ant-space-item{
      font-size: 12px;
  }
</style>
